import { ChangeDetectionStrategy, Component, inject, input, output, viewChild } from '@angular/core';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { AgGridAngular } from 'ag-grid-angular';
import { MappingSchedule } from '../../models/mapping-schedule';
import { FindProjectScheduleGridOptions, FindProjectScheduleGridOptionsService } from './columns';
import { FindProjectScheduleService } from './find-project-schedule.service';

@Component({
  selector: 'app-find-project-schedule',
  templateUrl: './find-project-schedule.component.html',
  styleUrls: ['./find-project-schedule.component.scss'],
  imports: [
    AgGridAngular,
    DialogModule,
    ButtonDirective,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    FindProjectScheduleService,
    FindProjectScheduleGridOptionsService,
  ],
})
export class FindProjectScheduleComponent {
  private service = inject(FindProjectScheduleService);
  findProjectScheduleGridOptionsService = inject(FindProjectScheduleGridOptionsService);

  private readonly agGrid = viewChild(AgGridAngular);

  readonly projectId = input<number>(undefined);
  public loading: boolean = true;
  public findProjectScheduleGridOptions: FindProjectScheduleGridOptions
  public selectedRows: MappingSchedule[] = [];
  public saveSuccessful: boolean = false;

  readonly closeDialog = output<void>();

  constructor() {
    this.findProjectScheduleGridOptions = this.findProjectScheduleGridOptionsService.findProjectScheduleGridOptions;
  }

  async onGridReady(params) {
    this.refreshData();
  }

  public refreshData() {
    this.loading = true;
    this.service.getScheduleCandidateForProject(this.projectId()).subscribe(
      results => {
        this.loading = false;

        this.agGrid().api.setGridOption('rowData', results);
      }
    );
  }

  public onRowSelected(event) {
    this.selectedRows = [];

    this.agGrid().api.getSelectedRows().map(m => this.selectedRows.push(m));
  }

  public updateSchedule() {
    this.loading = true;

    this.service.updateSchedule(this.projectId(), this.selectedRows[0].ScheduleId)
      .subscribe(() => {
        this.loading = false;
        this.onCloseDialog();
      });
  }

  public onCloseDialog() {
    this.closeDialog.emit();
  }
}